import { __decorate } from "tslib";
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeTimePickerField = class AmFeTimePickerField extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.start = '';
    this.end = '';
  }
  get dateValueFormat() {
    if (this.valueFormat == 'HH:mm:ss') {
      return this.type == 1 ? this.pickerOptions.format : 'HH:mm';
    } else {
      return this.valueFormat;
    }
  }
  get newListeners() {
    if (this.type == 2 && this.isRange) {
      return Object.assign(this.$listeners, {
        change: this.setVal
      });
    }
    return this.$listeners;
  }
  valueChange(v) {
    if (this.type == 2 && this.isRange && Array.isArray(this.value)) {
      this.start = this.value[0];
      this.end = this.value[1];
    } else {
      this.start = '';
      this.end = '';
    }
  }
  setVal() {
    const value = [this.start, this.end];
    this.change(value);
  }
  get label_i18n() {
    return this.label === '时间' ? window.lowcode.i18n.get('apaas_amui_timepickerfield_label', '时间') : this.label;
  }
};
AmFeTimePickerField.componentName = 'AmFeTimePickerField';
__decorate([Prop({
  default: 1
})], AmFeTimePickerField.prototype, "type", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_timepickerfield_placeholder', '选择时间');
  }
})], AmFeTimePickerField.prototype, "placeholder", void 0);
__decorate([Prop({
  default: 'HH:mm:ss'
})], AmFeTimePickerField.prototype, "format", void 0);
__decorate([Prop({
  default: true
})], AmFeTimePickerField.prototype, "clearable", void 0);
__decorate([Prop({
  default: false
})], AmFeTimePickerField.prototype, "isRange", void 0);
__decorate([Prop()], AmFeTimePickerField.prototype, "pickerOptions", void 0);
__decorate([Prop({
  default: 'HH:mm:ss'
})], AmFeTimePickerField.prototype, "valueFormat", void 0);
__decorate([Watch('value', {
  immediate: true
})], AmFeTimePickerField.prototype, "valueChange", null);
AmFeTimePickerField = __decorate([Component({
  name: 'AmFeTimePickerField'
})], AmFeTimePickerField);
export default AmFeTimePickerField;